import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h2 className="text-2xl font-bold text-sky-400 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>
              Cartlixs
            </h2>
            <p className="text-slate-300 mb-4" style={{ fontFamily: 'Quicksand, sans-serif' }}>
              Fun, safe, and educational toys for kids of all ages. Trusted by thousands of families across the USA.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-sky-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-slate-300 hover:text-sky-400 transition-colors">Shop All</Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-sky-400 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-sky-400 transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Policies</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-slate-300 hover:text-sky-400 transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-slate-300 hover:text-sky-400 transition-colors">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-slate-300 hover:text-sky-400 transition-colors">Refund & Returns</Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="text-slate-300 hover:text-sky-400 transition-colors">Shipping Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-sky-400 mt-1 flex-shrink-0" />
                <span className="text-slate-300">192 A 22nd St #4699, New York, NY 30272</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-sky-400 flex-shrink-0" />
                <a href="tel:+1-888-435-6822" className="text-slate-300 hover:text-sky-400 transition-colors">
                  +1-888-435-6822
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-sky-400 flex-shrink-0" />
                <a href="mailto:support@cartlixs.store" className="text-slate-300 hover:text-sky-400 transition-colors">
                  support@cartlixs.store
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              &copy; {currentYear} Cartlixs. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <img src="https://cdn-icons-png.flaticon.com/32/349/349221.png" alt="Visa" className="h-6" />
              <img src="https://cdn-icons-png.flaticon.com/32/349/349228.png" alt="Mastercard" className="h-6" />
              <img src="https://cdn-icons-png.flaticon.com/32/349/349230.png" alt="American Express" className="h-6" />
              <img src="https://cdn-icons-png.flaticon.com/32/349/349265.png" alt="PayPal" className="h-6" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
